"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var _ = tslib_1.__importStar(require("@antv/util"));
var plot_1 = tslib_1.__importDefault(require("../../base/plot"));
var layer_1 = tslib_1.__importDefault(require("./layer"));
var GroupColumn = /** @class */ (function (_super) {
    tslib_1.__extends(GroupColumn, _super);
    function GroupColumn() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GroupColumn.prototype.createLayers = function (props) {
        var layerProps = _.deepMix({}, props);
        layerProps.type = 'groupColumn';
        _super.prototype.createLayers.call(this, layerProps);
    };
    GroupColumn.getDefaultOptions = layer_1.default.getDefaultOptions;
    return GroupColumn;
}(plot_1.default));
exports.default = GroupColumn;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/plots/group-column/index.js
// module id = 910
// module chunks = 37